import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const CurrentPassword: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="oldPassword"
      label={t("current_password")}
      rules={[{ required: true, message: t("Enter Current Password") }]}
    >
      <Input.Password />
    </Form.Item>
  );
};

export default CurrentPassword;
